enum ProjectNetwork {
  ALGORAND = 'algorand',
  SOLANA = 'solana',
  ETH = 'eth'
}

export default ProjectNetwork
